<div *ngIf="isLoading == false">
  <div class="col-12 text-center mb-2 text-dark" *ngIf="
    ContactsList == null &&
    Transmission == 'TEXT' &&
    isDoubleByte(Message) == false
  ">
    <small> {{ globalService.Get("SEND") }} {{ GetRecepientsCount() }}
      ({{ Message.length }}/153) => # {{ GetTransmissionCount(Message, 160) }} {{ globalService.Get(Transmission + "S")
      }}
    </small>
  </div>
  <div class="col-12 text-center mb-2 text-dark" *ngIf="
    ContactsList == null &&
    Transmission == 'TEXT' &&
    isDoubleByte(Message) == true
  ">
    <small> {{ globalService.Get("SEND") }} {{ GetRecepientsCount() }}
      ({{ Message.length }}/67) => # {{ GetTransmissionCount(Message, 70) }} {{ globalService.Get(Transmission + "S") }}
    </small>
  </div>

  <div class="col-12 text-center mb-2"
    *ngIf="RecepientsCount == null && ContactsList == null && Transmission == 'EMAIL'">
    <small>{{ globalService.Get("PERSONAL_EMAIL") }} </small>
  </div>
  <div class="col-12 text-center text-dark mb-2" *ngIf="
    Transmission == 'EMAIL'
  ">
    <small>{{ globalService.Get("SEND") }} {{ GetRecepientsCount() }}
      {{ globalService.Get(Transmission + "S") }}</small>
  </div>

  <div class="col-12 text-center mb-2"
    *ngIf="RecepientsCount == null && ContactsList == null && Transmission == 'NOTIFICATION'">
    <small>{{ globalService.Get("PERSONAL_NOTIFICATION") }} </small>
  </div>
  <div class="col-12 text-center text-dark mb-2" *ngIf="
    Transmission == 'NOTIFICATION'
  ">
    <small>{{ globalService.Get("SEND") }} {{ GetRecepientsCount() }}
      {{ globalService.Get(Transmission + "S") }}</small>
  </div>


  <div class="col-12 text-center text-dark mb-2" *ngIf="
    ContactsList != null &&
    Transmission == 'TEXT' &&
    isDoubleByte(Message) == false
  ">
    <small>{{ globalService.Get("SEND") }} {{ GetRecepientsCount() }}
      ({{ Message.length }}/153) => # {{ GetTransmissionCount(Message, 160) }} {{ globalService.Get(Transmission + "S")
      }}</small>
  </div>
  <div class="col-12 text-center text-dark mb-2" *ngIf="
    ContactsList != null &&
    Transmission == 'TEXT' &&
    isDoubleByte(Message) == true
  ">
    <small>{{ globalService.Get("SEND") }} {{ GetRecepientsCount() }}
      ({{ Message.length }}/67) => # {{ GetTransmissionCount(Message, 70) }} {{ globalService.Get(Transmission + "S") }}
    </small>
  </div>

  <div class="row">
    <div class="col-12" [class.text-left]="globalService.isRTL == false"
      [class.text-right]="globalService.isRTL == true">
      <label for="template" class="col-form-label mr-3 text-dark display-block"
        [class.mr-3]="globalService.isRTL == false" [class.ml-3]="globalService.isRTL == true">{{
        globalService.Get("TEMPLATE") }}</label>
    </div>
    <div class="col-12" [class.text-left]="globalService.isRTL == false"
      [class.text-right]="globalService.isRTL == true">
      <select id="template" class="form-select display-block" [class.classicRTL]="globalService.isRTL == true"
        [class.classic]="globalService.isRTL == false" style="width:90%;"
        (change)="onTemplateChanged($event.target.value)">
        <option [ngValue]="null" selected>
          {{ globalService.Get("NONE") }}
        </option>
        <option *ngFor="let template of templateArr; let curIndex = index" [ngValue]="template.id"
          [selected]="curIndex == selectedTemplateIndex">
          {{ template.name }}
        </option>
      </select>
    </div>

    <div class="col-12 mt-2" [class.text-left]="globalService.isRTL == false"
      [class.text-right]="globalService.isRTL == true">
      <button class="btn btn-small btn-primary m-1" (click)="OnNew()" [disabled]="NewTemplate == true">
        <span><i class="fas fa-file"></i></span>
      </button>
      <button class="btn btn-small btn-success m-1"
        [disabled]="curTemplate == null || NewTemplate == true || Message == null" (click)="SaveTemplate()">
        <span><i [class.fa-save]="SavingTemplate == false" [class.fa-spinner]="SavingTemplate == true"
            [class.fa-spin]="SavingTemplate == true" class="fas"></i></span>
      </button>
      <button class="btn btn-small btn-danger m-1" (click)="TemplateDelete = true" [disabled]="curTemplate == null">
        <span><i class="fas fa-trash"></i></span>
      </button>
    </div>
  </div>

  <div class="row mb-3" *ngIf="NewTemplate == true">
    <div class="col-12 col-md-6 col-lg-4">
      <div class="input-group">
        <input type="text" class="form-control" name="newTemplateName" [(ngModel)]="newTemplateName" required
          [placeholder]="globalService.Get('TEMPLATE_NAME')" />
        <div class="input-group-append">
          <button type="button" class="btn btn-success btn-small input-group-text"
            [disabled]="newTemplateName.trim() ==''" (click)="CreateNewTemplate()">
            <i class="fas fa-check"></i>
          </button>
        </div>
        <div class="input-group-append">
          <button type="button" class="btn btn-danger btn-small input-group-text" (click)="CancelTemplateCreation()">
            <i class="fas fa-times"></i>
          </button>
        </div>
      </div>
    </div>
  </div>

  <app-prompt-message [showForm]="TemplateSaved == true" color="success" (onClose)="TemplateSaved = false"
    [message]="globalService.Get('TEMPLATE_SAVED')">
  </app-prompt-message>

  <app-confirm-message [showForm]="TemplateDelete == true" (onConfirm)="DeleteTemplate()" color="danger"
    (onCancel)="TemplateDelete = false" [message]="'ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_TEMPLATE' | translate">
  </app-confirm-message>

  <div class="col dropdown ml-auto" [class.text-right]="globalService.isRTL == false"
    *ngIf="Transmission != 'NOTIFICATION'" [class.text-left]="globalService.isRTL == true">
    <button class="btn btn-primary btn-sm dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown"
      aria-haspopup="true" aria-expanded="false">
      {{ globalService.Get("MERGE_TAGS") }}
    </button>
    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton" *ngIf="ContactsList != null">
      <button class="dropdown-item btn-sm" (click)="insertName('[FirstName]')">
        {{ globalService.Get("FIRSTNAME") }}
      </button>
      <button class="dropdown-item btn-sm" (click)="insertName('[FullName]')">
        {{ globalService.Get("FULLNAME") }}
      </button>
      <button class="dropdown-item btn-sm" (click)="insertName('[AllNames]')">
        {{ globalService.Get("ALLNAMES") }}
      </button>
      <button class="dropdown-item btn-sm" (click)="insertName('[Attendees]')">
        {{ globalService.Get("ATTENDEES") }}
      </button>
      <button class="dropdown-item btn-sm" (click)="insertName('[Absentees]')">
        {{ globalService.Get("ABSENTEES") }}
      </button>
    </div>
  </div>
  <div *ngIf="Global == true">
    <app-comm-scope (scopeSelected)="ScopeChanged($event)"></app-comm-scope>
  </div>
  <div class="row text-dark" *ngIf="Transmission == 'EMAIL'">
    <div class="col" [class.text-left]="globalService.isRTL == false" [class.text-right]="globalService.isRTL == true">
      <label>{{ 'SUBJECT' | translate }}</label>
      <input class="form-control" name="Subject" [(ngModel)]="Subject" [placeholder]="'MESSAGE_FROM_CHURCH' | translate" />
    </div>
  </div>
  <div class="row text-dark pt-2" *ngIf="Transmission == 'NOTIFICATION'">
    <div class="col" [class.text-left]="globalService.isRTL == false" [class.text-right]="globalService.isRTL == true">
      <label>{{ 'TITLE' | translate }}</label>
      <input class="form-control" maxlength="40" name="Subject" [(ngModel)]="Subject" [placeholder]="'TITLE' | translate" />
    </div>
  </div>
  <div class="row text-dark pt-2" *ngIf="Transmission == 'NOTIFICATION'">
    <div class="form-group col-12" [class.text-left]="globalService.isRTL == false"
      [class.text-right]="globalService.isRTL == true">
      <label>{{ 'SUBTITLE' | translate }}</label>
      <textarea name="subtitle" class="form-control rounded-2 subtitle" style="max-width: 100%; width: 100%" rows="3"
        [maxlength]="150" [(ngModel)]="Subtitle" [placeholder]="'SUBTITLE' | translate"></textarea>
    </div>
  </div>
  <div class="row" *ngIf="Transmission == 'TEXT'">
    <div class="form-group col-12">
      <label class="text-dark">{{ 'BODY' | translate }}</label>
      <textarea class="form-control rounded-2" style="max-width: 100%; width: 100%" rows="6" [maxlength]="2000"
        [class.text-primary]="isDoubleByte(Message) == true" [(ngModel)]="Message"
        [placeholder]="globalService.Get('YOUR_MESSAGE')" #myMessage (click)="getCaretPos(myMessage)"
        (change)="getCaretPos(myMessage)"></textarea>
    </div>
  </div>
  <div class="row" [hidden]="Transmission == 'TEXT'">
    <div class="form-group col-12 text-dark text-left">
      <label class="text-dark pt-2 pr-2">{{ 'BODY' | translate }}</label>
      <button *ngIf="loadEditor == false" class="btn btn-outline-primary btn-sm" (click)="loadEditor = true">
        {{ 'OPEN_RICH_EDITOR' | translate }}</button>
      <editor *ngIf="loadEditor" [(ngModel)]="Message" [init]="globalService.editorConfig"
        apiKey="p4ups0ehnkfioskf90008v69wieluyp8tvmwwd5rap1ycqsz">
      </editor>
    </div>
    <!-- <div class="form-group col-12 text-dark text-left"> 
      <label class="text-dark pt-2">Body</label>
      <editor [(ngModel)]="Message" [init]="globalService.editorConfig" apiKey="p4ups0ehnkfioskf90008v69wieluyp8tvmwwd5rap1ycqsz"></editor>
    </div> -->
  </div>
  <div class="col-12 text-left p-0">
    <mat-slide-toggle class="text-dark" [(ngModel)]="scheduleSend" [disabled]="disabled">
      {{ globalService.Get("SCHEDULESEND") }}
    </mat-slide-toggle>
  </div>
  <div class="row my-3 text-dark text-left" *ngIf="scheduleSend == true">
    <div class="col-6">
      <label for="date" class="text-secondary">{{
        globalService.Get("SENDDATE") }}</label>
      <input name="date" type="date" class="form-control" [(ngModel)]="currentDate"
        [ngModelOptions]="{standalone: true}" />
    </div>
    <div class="col-6">
      <label for="Time">{{
        globalService.Get("SENDTIME")
        }}</label>
      <input type="time" id="startTime" class="form-control" [(ngModel)]="startTime"
        [ngModelOptions]="{standalone: true}" />
    </div>
  </div>
  <div class="row">
    <div class="col-12" *ngIf="Acknowledge != ''">
      <app-user-message [type]="'success'" class="text-center" (close)="Acknowledge = ''; Sent = false">
        {{ Acknowledge }}
      </app-user-message>
    </div>
    <div class="col-12" *ngIf="ConfirmSend == true">
      <app-user-message *ngIf="ConfirmSend == true" [type]="'warning'" class="text-center mt-2" (close)="ConfirmSend = false">
        {{ globalService.Get("THIS_WILL_SEND_TO") }}
        {{ GetRecepientsCount() }}
        {{ globalService.Get("MESSAGES") }} {{ globalService.Get("PROCEED?") }}
      </app-user-message>
    </div>
  </div>
  <div class="row pb-2" *ngIf="Transmission == 'EMAIL' || Transmission == 'TEXT'">
    <div class="col-12 text-right">
      <app-attachment #attachmentComponent [transmission]="Transmission">
      </app-attachment>
    </div>
  </div>
  <div class="row">
    <div class="text-right form-group col-12">
      <app-prompt-message [showForm]="subscriptionError == true" color="danger" (onClose)="subscriptionError = false"
        [message]="'MONTHLY_TEXT_PACKAGE_DOESN_T_ALLOW_THIS_BATCH_PLEASE_REDUCE_YOUR_SELECTI' | translate">
      </app-prompt-message>
    </div>
  </div>
  <div class="row">
    <div class="text-right form-group col-12 col-sm-6">
      <button class="btn btn-primary btn-block nopadding" (click)="sendSelf()" [disabled]=" NewTemplate == true || Sent || ( Transmission == 'TEXT' && (Message == null || Message.trim() == '') && attachmentComponent?.getAttachments()?.length == 0) || ( Transmission != 'TEXT' && (Message == null || Message.trim() == ''))">
        <span>{{ globalService.Get(" SELF") }}<i class="fas fa-edit" [class.ml-2]="globalService.isRTL == false"
        [class.mr-2]="globalService.isRTL == true"></i></span>
      </button>
    </div>
    <div class="text-right form-group col-12 col-sm-6" *ngIf="ConfirmSend == false">
      <button class="btn btn-success btn-block nopadding" (click)="send()" [disabled]="isCommunicationDisabled()">
        {{ 'SEND_VALUE0_VALUE1' | translate:{value0:(globalService.Get(Transmission)),value1:(GetRecepientsCount())} }}<i class="fas" [class.fa-sms]="Transmission == 'TEXT' && isSending == false"
          [class.fa-envelope]="Transmission == 'EMAIL' && isSending == false" [class.fa-spinner]="isSending == true"
          [class.fa-spin]="isSending == true" [class.ml-2]="globalService.isRTL == false"
          [class.mr-2]="globalService.isRTL == true"></i>
      </button>
    </div>
    <div class="text-right form-group col-12 col-sm-6 col-md-3 col-lg-5 ml-auto" *ngIf="ConfirmSend == true">
      <button class="btn btn btn-warning btn-block" (click)="send()"
        [disabled]="NewTemplate == true || isDemo() || Sent == true">
        {{ globalService.Get("CONFIRM") }}
      </button> 
    </div>
  </div>
</div>